import comp from "./NotificationList";
export default comp;
